module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/client-manage-assignments/client-manage-assignments.component.scss
// module id = ./src/app/admin/client-manage-assignments/client-manage-assignments.component.scss
// module chunks = main